export const GetRepayment = ({ basketOwnerId, coinId }) =>
  `/Inv_Basket/GetRepayment?BasketOwnerId=${basketOwnerId}&CoinId=${coinId}`;

export const GetRepaymentAmountMax = ({ basketOwnerId, coinId }) =>
  `/Inv_Basket/GetRepaymentAmountMax?BasketOwnerId=${basketOwnerId}&CoinId=${coinId}`;

export const RepaymentInsert =
  "/Inv_Basket/RepaymentInsert";
